export default __webpack_public_path__ + "static/media/register.0852cef4.jpeg";